import { MouseEvent } from "react";
import { EnumMouseButtons } from "src/types/common-enum";

export const triggerCallbackOnMiddleClickEvent =
    (callback?: (event: MouseEvent<HTMLElement, globalThis.MouseEvent>) => void) => (event: MouseEvent<HTMLElement, globalThis.MouseEvent>) => {
        if (event.button === EnumMouseButtons.Auxiliary) {
            callback?.(event);
        }
    };
